import type { LineLabelConfig } from '@examdojo/core/widget';

// =============================================================================
// TYPES
// =============================================================================

export interface LengthAnnotationElement {
  type: 'LengthAnnotation';
  params: {
    /** Edge port ref (e.g., "t1.edge.AB") */
    of: string;
    /** Perpendicular offset distance from the edge (default: 0.5) */
    offset?: number;
  };
  label?: LineLabelConfig;
}

// =============================================================================
// DEFAULTS
// =============================================================================

export const LENGTH_ANNOTATION_DEFAULTS = {
  offset: 0.5,
} as const;
